import React from "react";
import { ModalProps, Modal } from "semantic-ui-react";
import { useTexts } from "@common/hooks/useTexts";
import { IPersonFormData, IPerson } from "../../models/IPerson";
import PersonForm from "./PersonForm";
import { useUpdatePerson } from "../../data/persons/useUpdatePerson";
import { useLoggedInUser } from "@/@auditoinnit/auditoinnit/auth/hooks/useLoggedInUser";

interface EditPersonModalProps extends ModalProps {
    onSuccess: (person: IPerson) => void;
    onCancel: () => void;
    person: IPerson;
    requiredCerts?: Array<string>;
    inputForCertStartDate?: boolean;
};

const EditPersonModal: React.FC<EditPersonModalProps> = ({
    onSuccess,
    onCancel,
    person,
    requiredCerts,
    inputForCertStartDate,
    ...modalProps
}) => {

    const texts = useTexts((t) => ({
        addCompany: t("Muokkaa tietoja"),
        cannotEditUserInfo: t("Et voi muokata käyttäjän tietoja, joka käyttää sovellusta"),
    }));
    const loggedInUser = useLoggedInUser()
    const { update, updating, updateError } = useUpdatePerson();

    const _onSubmit = async (values: IPersonFormData) => {
        const result = await update({
            ...person,
            ...values,
            id: person.id
        });
        if (result.isSuccess) {
            onSuccess(result.value);
        };
    };

    const anotherAppUser = Boolean(person.loggedAt?.length) && loggedInUser.hprPersonId !== person.id;

    return (
        <Modal closeIcon className="EditPersonModal" {...modalProps} onClose={onCancel}>
            <Modal.Content>
                <h3> {texts.addCompany} </h3>
                <p> {person.fullname} </p>

                <PersonForm
                    initialData={person}
                    onSubmit={_onSubmit}
                    onCancel={onCancel}
                    loading={updating}
                    requiredCerts={requiredCerts}
                    disabledPersonalDetail={anotherAppUser}
                    formError={updateError}
                    inputForCertStartDate={inputForCertStartDate}
                />

            </Modal.Content>
        </Modal>
    );
};

export default EditPersonModal;
